import ContentHeader from '../../../widgets/contentHeader/ContentHeader';
import { PanoramaFilters } from '../../../widgets/panoramaFilters';

// Страница для отображения фильтров панорамы
export function PanoramaFiltersPage() {
    return (
        <>
            <ContentHeader title="Настройка панорамы" />
            <PanoramaFilters type="page" />
        </>
    );
}
